import { apparelProductTypeIds, photoBookIds } from 'src/api/productTypes';

// eslint-disable-next-line import/prefer-default-export
export const isPhotobook = (productTypeId: number) => photoBookIds.indexOf(productTypeId) >= 0;

// Prefer the BE-provided flag (single source of truth from ProductType::$apparelProductTypes).
// Fall back to the legacy FE list only while a client may predate the BE integration-layer change;
// the list can be removed once the BE flag is deployed everywhere.
export const isApparelProduct = (productTypeId: number) => {
  const { isApparel } = window.integrationLayer || {};
  if (typeof isApparel === 'boolean') {
    return isApparel;
  }
  return apparelProductTypeIds.indexOf(productTypeId) >= 0;
};

const SIMPLE_PHOTO_MUGS = ['simple-photo', 'simple-photo-left'];

export const checkSimplePhotoMug = (attributeValue: string) => SIMPLE_PHOTO_MUGS.indexOf(attributeValue) !== -1;
